import palette from '@lib/core/src/theme/palette';
import { styled, Stack, alpha } from '@mui/material';

export const Container = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  paddingTop: '27px',
  width: '100%'
});

const BORDER = '3px solid rgba(47, 47, 47, 0.10)';
const BORDER_RADIUS = '12px';

export const DismissButton = styled(Stack, {
  shouldForwardProp: prop => prop !== 'isPressed'
})<{ isPressed?: boolean }>(({ isPressed }) => ({
  flexDirection: 'row',
  padding: '14px 12px',
  justifyContent: 'center',
  alignItems: 'center',
  height: '44px',
  width: '150px',
  cursor: 'pointer',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  MsUserSelect: 'none',
  willChange: 'background',
  '&:hover': {
    background: `radial-gradient(640.12% 363.58% at 67.5% 43.18%, ${palette.white} 0%, ${palette.red[300]} ${isPressed ? '50%' : '100%'})`,
    border: `1px solid ${palette.red[200]}`
  },
  border: BORDER,
  background: palette.white,
  gap: '4px',
  borderRadius: BORDER_RADIUS,
  fontSize: '13px',
  fontWeight: '600',
  lineHeight: '16px'
}));

export const ApproveButton = styled(Stack, {
  shouldForwardProp: prop => prop !== 'isPressed'
})<{ isPressed?: boolean; disabled?: boolean }>(({ isPressed, disabled }) => ({
  flexDirection: 'row',
  padding: '14px 12px',
  justifyContent: 'center',
  alignItems: 'center',
  height: '44px',
  width: '150px',
  cursor: 'pointer',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  MsUserSelect: 'none',
  border: BORDER,
  background: palette.white,
  willChange: 'background',
  '&:hover': {
    background: `radial-gradient(640.12% 363.58% at 67.5% 43.18%, ${palette.white} 0%, ${palette.green[400]} ${isPressed ? '50%' : '100%'})`,
    border: `1px solid ${palette.green[500]}`
  },
  gap: '4px',
  borderRadius: BORDER_RADIUS,
  fontSize: '13px',
  fontWeight: '600',
  lineHeight: '16px',
  opacity: disabled ? 0.5 : 1
}));

export const SnoozeButton = styled(Stack, {
  shouldForwardProp: prop => prop !== 'isPressed'
})<{ isPressed?: boolean }>(({ isPressed }) => ({
  padding: '8px 12px',
  justifyContent: 'center',
  alignItems: 'center',
  height: '32px',
  width: '96px',
  cursor: 'pointer',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  MsUserSelect: 'none',
  backgroundColor: alpha(palette.white, 0.3),
  backdropFilter: 'blur(10px)',
  '&:hover': {
    backgroundColor: alpha(palette.white, isPressed ? 0.1 : 0.2)
  },
  border: BORDER,
  gap: '4px',
  borderRadius: BORDER_RADIUS,
  fontSize: '13px',
  fontWeight: '500',
  lineHeight: '16px'
}));
